
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/hub/templates/filter"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h2 class=\"sr-only\">Chat & Activity</h2>\n<div class='hubComponent-filterIcon'></div>\n<div class='hubComponent-filterDropdownRegion'></div>\n";
},"useData":true});
    }).call(this);
  